import * as Schema from "effect/Schema";
import { EnvironmentId, ProjectId, ThreadId, TrimmedNonEmptyString } from "./baseSchemas.js";
export const ExecutionEnvironmentPlatformOs = Schema.Literals([
    "darwin",
    "linux",
    "windows",
    "unknown",
]);
export const ExecutionEnvironmentPlatformArch = Schema.Literals(["arm64", "x64", "other"]);
export const ExecutionEnvironmentPlatform = Schema.Struct({
    os: ExecutionEnvironmentPlatformOs,
    arch: ExecutionEnvironmentPlatformArch,
});
export const ExecutionEnvironmentDescriptor = Schema.Struct({
    environmentId: EnvironmentId,
    label: TrimmedNonEmptyString,
    platform: ExecutionEnvironmentPlatform,
    serverVersion: Schema.NullOr(TrimmedNonEmptyString),
    clientBuild: Schema.NullOr(TrimmedNonEmptyString),
});
export const EnvironmentConnectionState = Schema.Literals([
    "connecting",
    "connected",
    "disconnected",
    "error",
]);
export const ScopedProjectRef = Schema.Struct({
    environmentId: EnvironmentId,
    projectId: ProjectId,
});
export const ScopedThreadRef = Schema.Struct({
    environmentId: EnvironmentId,
    threadId: ThreadId,
});
export const ScopedThreadSessionRef = Schema.Struct({
    environmentId: EnvironmentId,
    threadId: ThreadId,
});
